export const RadixBase = 10
export const DefaultSlideIndex = 0
